export const FETCH_CONTRACTS = 'contractActions/FETCH_CONTRACTS';
export const FETCH_CONTRACTS_SUCCESS =
  'contractActions/FETCH_CONTRACTS_SUCCESS';
export const FETCH_CONTRACTS_FAILED = 'contractActions/FETCH_CONTRACTS_FAILURE';
export const FETCH_COMPANY_CONTRACTS =
  'contractActions/FETCH_COMPANY_CONTRACTS';
export const FETCH_COMPANY_CONTRACTS_SUCCESS =
  'contractActions/FETCH_COMPANY_CONTRACTS_SUCCESS';
export const FETCH_COMPANY_CONTRACTS_FAILED =
  'contractActions/FETCH_COMPANY_CONTRACTS_FAILURE';
export const UPDATE_CONTRACT = 'contractActions/UPDATE_CONTRACT';
export const UPDATE_CONTRACT_SUCCESS =
  'contractActions/UPDATE_CONTRACT_SUCCESS';
export const UPDATE_CONTRACT_FAILED = 'contractActions/UPDATE_CONTRACT_FAILED';

export function fetchContracts(filters) {
  return {
    type: FETCH_CONTRACTS,
    filters,
  };
}

export function fetchContractsSuccess(details) {
  return {
    type: FETCH_CONTRACTS_SUCCESS,
    details,
  };
}

export function fetchContractsFailed(err) {
  return {
    type: FETCH_CONTRACTS_FAILED,
    err,
  };
}

export function fetchCompanyContracts(companyId, filters) {
  return {
    type: FETCH_COMPANY_CONTRACTS,
    companyId,
    filters,
  };
}

export function fetchCompanyContractsSuccess(details) {
  return {
    type: FETCH_COMPANY_CONTRACTS_SUCCESS,
    details,
  };
}

export function fetchCompanyContractsFailed(err) {
  return {
    type: FETCH_COMPANY_CONTRACTS_FAILED,
    err,
  };
}

export function updateContract(details) {
  return {
    type: UPDATE_CONTRACT,
    details,
  };
}

export function updateContractSuccess(details) {
  return {
    type: UPDATE_CONTRACT_SUCCESS,
    details,
  };
}

export function updateContractFailed(err) {
  return {
    type: UPDATE_CONTRACT_FAILED,
    err,
  };
}
